import { render, staticRenderFns } from "./new_03.vue?vue&type=template&id=1fb5112a&scoped=true"
import script from "./new_03.vue?vue&type=script&lang=js"
export * from "./new_03.vue?vue&type=script&lang=js"
import style0 from "./new_03.vue?vue&type=style&index=0&id=1fb5112a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5112a",
  null
  
)

export default component.exports